import { RpcClient } from "@nestjs-rpc/client";
import axios, { AxiosError, AxiosResponse } from "axios";
import { LinkoErrorResponse, TypedLinkoError } from "./exceptions-message";
import { notifyLinkoUnauthorized } from "./linko-unauthorized";
import { FirstParameter } from "./model-table";

export { setLinkoUnauthorizedHandler } from "./linko-unauthorized";

type RpcManifest = import("server/src/rpc.config").RpcManifest;

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError<LinkoErrorResponse>) => {
    if (error.response?.status === 401) {
      await notifyLinkoUnauthorized(error.config?.url);
    }

    if (error.response) {
      const typedError = TypedLinkoError.fromAxiosError(error);
      if (typedError) {
        error.response.data = typedError as any;
        (error as any).linkoError = typedError;
      }
    }
    throw error;
  },
);

export const client = new RpcClient<RpcManifest>({
  baseUrl: ENV.serverBaseUrl,
  apiPrefix: "rpc",
  axiosInstance,
  requestOptions: {
    withCredentials: true,
  },
});

export const linko = client.routers();

export type MethodResponse<
  T extends (...arg: any[]) => Promise<AxiosResponse<any>>,
> = Awaited<ReturnType<T>>["data"];

export type MethodBody<
  T extends (...arg: any[]) => Promise<AxiosResponse<any>>,
> = FirstParameter<T>;
